<template>
  <div class="lc-wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <!-- Sidebar -->
    <div
      class="lc-sidebar"
      :class="{ 'lc-sidebar--open': $sidebar.showSidebar }"
    >
      <!-- Logo -->
      <div class="lc-sidebar__logo">
        <div class="lc-sidebar__logo-mark">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 2L3 7v10l9 5 9-5V7L12 2z"
              fill="#4eab3e"
              opacity=".9"
            />
            <path
              d="M12 2v20M3 7l9 5 9-5"
              stroke="#fff"
              stroke-width="1.5"
              stroke-opacity=".4"
            />
          </svg>
        </div>
        <div class="lc-sidebar__logo-text">
          <span class="lc-sidebar__logo-title">{{ titulo }}</span>
          <span class="lc-sidebar__logo-sub">Lead Center</span>
        </div>
      </div>

      <!-- User -->
      <div class="lc-sidebar__user">
        <div class="lc-sidebar__user-avatar">{{ nomeInicial }}</div>
        <div class="lc-sidebar__user-info">
          <span class="lc-sidebar__user-name">{{ nome }}</span>
          <span class="lc-sidebar__user-role">Administrador</span>
        </div>
      </div>

      <!-- Nav -->
      <nav class="lc-sidebar__nav">
        <div class="lc-sidebar__nav-label">Menu</div>

        <router-link
          to="/dashboard"
          class="lc-nav-item"
          active-class="lc-nav-item--active"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <rect x="3" y="3" width="7" height="7" />
            <rect x="14" y="3" width="7" height="7" />
            <rect x="3" y="14" width="7" height="7" />
            <rect x="14" y="14" width="7" height="7" />
          </svg>
          <span>Dashboard</span>
        </router-link>

        <router-link
          to="/dashboard-incumprimento"
          class="lc-nav-item"
          active-class="lc-nav-item--active"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
            />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
          <span>Incumprimento</span>
        </router-link>

        <router-link
          to="/dashboard-taxas"
          class="lc-nav-item"
          active-class="lc-nav-item--active"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <line x1="12" y1="1" x2="12" y2="23" />
            <path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" />
          </svg>
          <span>Taxas Website</span>
        </router-link>

        <!-- <router-link
          to="/dashboard-consultores"
          class="lc-nav-item"
          active-class="lc-nav-item--active"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 00-3-3.87" />
            <path d="M16 3.13a4 4 0 010 7.75" />
          </svg>
          <span>Consultores</span>
        </router-link> -->

        <router-link
          to="/dashboard-rgpd"
          class="lc-nav-item"
          active-class="lc-nav-item--active"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
          <span>RGPD</span>
        </router-link>
      </nav>

      <!-- Logout -->
      <div class="lc-sidebar__footer">
        <button class="lc-nav-item lc-nav-item--logout" @click="logout()">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
          <span>Sair</span>
        </button>
      </div>
    </div>

    <!-- Overlay mobile -->
    <div
      class="lc-sidebar-overlay"
      v-if="$sidebar.showSidebar"
      @click="toggleSidebar"
    ></div>

    <!-- Main -->
    <div class="lc-main">
      <!-- Top bar -->
      <header class="lc-topbar">
        <button class="lc-topbar__toggle" @click="toggleSidebar">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
        <span class="lc-topbar__title">{{ $route.name }}</span>
        <div class="lc-topbar__right">
          <span class="lc-topbar__user">{{ nome }}</span>
        </div>
      </header>

      <!-- Content -->
      <main class="lc-content" @click="closeSidebarOnMobile">
        <router-view name="header"></router-view>
        <router-view></router-view>
      </main>

      <!-- Footer -->
      <footer class="lc-footer">
        <span>© {{ ano }} Lead Center · Reorganiza</span>
      </footer>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        titulo: "",
        nome: "",
        ano: new Date().getFullYear(),
      };
    },
    computed: {
      nomeInicial() {
        return this.nome ? this.nome.charAt(0).toUpperCase() : "U";
      },
    },
    methods: {
      logout() {
        localStorage.removeItem("lc_Dashboard_Login");
        this.$router.push("/login");
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      closeSidebarOnMobile() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      },
      capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
      },
    },
    mounted() {
      const login = JSON.parse(localStorage.getItem("lc_Dashboard_Login"));
      this.titulo = this.capitalize(login.cliente);
      this.nome = this.capitalize(login.nome);
    },
  };
</script>

<style scoped>
  /* ── Layout ── */
  .lc-wrapper {
    display: flex;
    min-height: 100vh;
    background: #f8f9fb;
  }

  /* ── Sidebar ── */
  .lc-sidebar {
    width: 240px;
    flex-shrink: 0;
    background: #141720;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    transition: transform 0.25s ease;
    overflow-y: auto;
  }

  /* ── Logo ── */
  .lc-sidebar__logo {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 22px 20px 18px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  }
  .lc-sidebar__logo-mark {
    width: 36px;
    height: 36px;
    background: rgba(78, 171, 62, 0.15);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .lc-sidebar__logo-title {
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    display: block;
    line-height: 1.2;
  }
  .lc-sidebar__logo-sub {
    font-size: 10px;
    color: rgba(255, 255, 255, 0.35);
    text-transform: uppercase;
    letter-spacing: 0.08em;
    display: block;
  }

  /* ── User ── */
  .lc-sidebar__user {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 16px 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    margin-bottom: 8px;
  }
  .lc-sidebar__user-avatar {
    width: 32px;
    height: 32px;
    background: linear-gradient(135deg, #4eab3e, #a9d42c);
    border-radius: 8px;
    font-size: 13px;
    font-weight: 700;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .lc-sidebar__user-name {
    font-size: 13px;
    font-weight: 600;
    color: #fff;
    display: block;
    line-height: 1.2;
  }
  .lc-sidebar__user-role {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.35);
    display: block;
  }

  /* ── Nav ── */
  .lc-sidebar__nav {
    padding: 0 10px;
    flex: 1;
  }
  .lc-sidebar__nav-label {
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: rgba(255, 255, 255, 0.2);
    padding: 8px 10px 6px;
  }

  .lc-nav-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 12px;
    border-radius: 7px;
    color: rgba(255, 255, 255, 0.5);
    font-size: 13px;
    font-weight: 500;
    text-decoration: none;
    margin-bottom: 2px;
    transition: all 0.18s ease;
    width: 100%;
    background: none;
    border: none;
    cursor: pointer;
    text-align: left;
  }
  .lc-nav-item:hover {
    background: rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.85);
  }
  .lc-nav-item--active {
    background: rgba(78, 171, 62, 0.15) !important;
    color: #fff !important;
    border-left: 3px solid #4eab3e;
    padding-left: 9px;
  }
  .lc-nav-item--active svg {
    color: #4eab3e;
  }

  /* ── Footer ── */
  .lc-sidebar__footer {
    padding: 12px 10px 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
  }
  .lc-nav-item--logout {
    color: rgba(255, 255, 255, 0.3) !important;
  }
  .lc-nav-item--logout:hover {
    color: #ff6b6b !important;
    background: rgba(255, 107, 107, 0.08) !important;
  }

  /* ── Overlay ── */
  .lc-sidebar-overlay {
    display: none;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 99;
  }

  /* ── Main ── */
  .lc-main {
    margin-left: 240px;
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  /* ── Topbar ── */
  .lc-topbar {
    height: 60px;
    background: #fff;
    border-bottom: 1px solid #e5e7eb;
    display: flex;
    align-items: center;
    padding: 0 24px;
    gap: 16px;
    position: sticky;
    top: 0;
    z-index: 50;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }
  .lc-topbar__toggle {
    background: none;
    border: none;
    cursor: pointer;
    color: #6b7280;
    padding: 6px;
    border-radius: 6px;
    display: none;
    transition: background 0.2s;
  }
  .lc-topbar__toggle:hover {
    background: #f3f4f6;
  }
  .lc-topbar__title {
    font-size: 14px;
    font-weight: 600;
    color: #111318;
    flex: 1;
  }
  .lc-topbar__right {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .lc-topbar__user {
    font-size: 13px;
    color: #6b7280;
    font-weight: 500;
  }

  /* ── Content ── */
  .lc-content {
    padding: 28px 28px 24px;
    flex: 1;
    margin-top: 4px;
  }

  /* ── Footer ── */
  .lc-footer {
    padding: 14px 28px;
    border-top: 1px solid #e5e7eb;
    font-size: 12px;
    color: #9ca3af;
    text-align: center;
  }

  /* ── Mobile ── */
  @media (max-width: 991px) {
    .lc-sidebar {
      transform: translateX(-100%);
    }
    .lc-sidebar--open {
      transform: translateX(0);
    }
    .lc-sidebar-overlay {
      display: block;
    }
    .lc-main {
      margin-left: 0;
    }
    .lc-topbar__toggle {
      display: flex;
    }
  }
</style>
